<div>
  <div class="intro-section" id="intro">
    <p>
      THE FOLLOWING TERMS AND CONDITIONS GOVERN YOUR ACCESS TO AND USE OF THE
      ACC DATA HUB (hereinafter, the <b>"SERVICES"</b>) MADE AVAILABLE BY OR ON
      BEHALF OF APPALACHIAN COMMUNITY CAPITAL CORPORATION (<b>"COMPANY"</b>)
      DURING THE FREE TRIAL PERIOD.
    </p>
    <div class="important-notice">
      <p>
        <strong>IMPORTANT:</strong> BY REGISTERING ON THE COMPANY'S WEBSITE AND
        ACCESSING THE SERVICES, YOU ACCEPT AND AGREE TO THE FOLLOWING TERMS AND
        CONDITIONS.
      </p>
    </div>
  </div>
  <h3 id="trial-period">1. Free Trial Period</h3>
  <p>
    If you register on the Company's website for a free trial period of the
    Services, Company will make the Services available to you on a trial basis,
    free of charge, until the earlier of:
  </p>
  <ul>
    <li>
      <strong>(a)</strong> the end of the free trial period for which you
      registered to use the Services;
    </li>
    <li>
      <strong>(b)</strong> the start date of any payable Services ordered by
      you; or
    </li>
    <li><strong>(c)</strong> termination by Company in its sole discretion.</li>
  </ul>
  <p>
    During your free trial period, you may access and use the Services for
    evaluation purposes only. You shall be responsible for maintaining the
    security of your login credentials used to access the Services and you shall
    not share those credentials with any third party or otherwise permit any
    third party to use the Services.
  </p>
  <h3 id="restrictions">2. Usage Restrictions</h3>
  <p>
    You acknowledge that all right, title and interest in and to the Services
    and all underlying software, technology and other intellectual property
    belong exclusively to the Company or its licensors. You shall at no time:
  </p>
  <div class="restrictions-list">
    <ul>
      <li>
        <strong>(a)</strong> copy any feature, design or graphic in the
        Services;
      </li>
      <li>
        <strong>(b)</strong> attempt to circumvent any security device or access
        or derive the source code or architecture of any Services;
      </li>
      <li>
        <strong>(c)</strong> use or access any Services in order to build a
        competitive solution or to assist someone else to build a competitive
        solution;
      </li>
      <li>
        <strong>(d)</strong> load or penetration test the Services or otherwise
        use any Services in any way that is, or could reasonably be expected to
        be, detrimental to Company's ability to provide services to any other
        customer;
      </li>
      <li>
        <strong>(e)</strong> use the Services in a manner that violates any
        applicable law, ordinance, regulation or administrative order; or
      </li>
      <li>
        <strong>(f)</strong> permit any third party to do any of the foregoing.
      </li>
    </ul>
  </div>
  <h3 id="warranties">3. Disclaimer of Warranties</h3>
  <p>
    COMPANY MAKES NO WARRANTY OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY
    OR OTHERWISE IN CONNECTION WITH THESE TRIAL PERIOD TERMS AND CONDITIONS.
    WITHOUT LIMITING THE FOREGOING, COMPANY IS PROVIDING THE SERVICES ON AN "AS
    IS" AND "AS AVAILABLE" BASIS AND COMPANY DOES NOT MAKE, AND HEREBY EXPRESSLY
    DISCLAIMS, TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, ALL
    REPRESENTATIONS, WARRANTIES AND CONDITIONS, EXPRESS OR IMPLIED, WITH RESPECT
    TO THE SERVICES OR THEIR PERFORMANCE, INCLUDING THE WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.
  </p>
  <p>
    IN PARTICULAR, COMPANY DOES NOT WARRANT THAT THE SERVICES WILL MEET YOUR
    EXPECTATIONS OR BE SECURE, ACCURATE, ERROR-FREE, OR OPERATE ON AN
    UNINTERRUPTED BASIS OR IN COMBINATION WITH ANY OTHER HARDWARE, SOFTWARE OR
    SYSTEM. NOTWITHSTANDING THE FOREGOING, AND IN NO WAY LIMITING THE FOREGOING
    DISCLAIMER, COMPANY SPECIFICALLY DISCLAIMS ANY SCORES OR RESULTS OBTAINED
    FROM TOOLS AVAILABLE ON THE DATA HUB, AND IN NO WAY SHOULD THE INFORMATION
    AVAILABLE ON THE DATA HUB BE USED TO ADVISE ON THE ELIGIBILITY AND/OR
    QUALITY OF POTENTIAL BORROWERS OR ENTITIES.
  </p>
  <p>
    END USER MUST CONDUCT ITS OWN DUE DILIGENCE AND EXAMINE AND ASSESS THE
    INFORMATION PROVIDED FOR ITSELF. COMPANY ALSO IN NO WAY GUARANTEES THAT USE
    OF THE DATA HUB WILL RESULT IN ANY BUSINESS FOR END USER, OR THE PROVISION
    OF ELIGIBLE BORROWERS THAT END USER MAY DO BUSINESS WITH.
  </p>
  <h3 id="liability">4. Limitation of Liability</h3>
  <p>
    WITHOUT LIMITING THE FOREGOING, COMPANY WILL NOT BE LIABLE FOR ANY PROBLEMS
    WITH THE SERVICES ATTRIBUTABLE TO THE INTERNET, FORCE MAJEURE OR CUSTOMER'S
    OR ANY AUTHORIZED USER'S NETWORK OR ABILITY TO ACCESS THE INTERNET.
    COMPANY'S AGGREGATE LIABILITY TO YOU ARISING UNDER OR IN CONNECTION WITH
    THESE TRIAL PERIOD TERMS AND CONDITIONS, WHETHER IN CONTRACT, TORT
    (INCLUDING NEGLIGENCE) OR OTHERWISE, SHALL IN NO EVENT EXCEED USD 50.00
    (fifty US dollars).
  </p>
  <h3 id="indemnification">5. Indemnification</h3>
  <p>
    You shall indemnify, defend and hold harmless Company and its affiliates and
    their respective employees and agents from and against any loss, cost,
    damage or expense (including reasonable attorneys' fees and costs) in
    respect of any claim that relates to:
  </p>
  <ul>
    <li>
      <strong>(a)</strong> your data or any other content or materials input to,
      stored in or processed by any Company system in connection with your use
      of the Services hereunder; or
    </li>
    <li>
      <strong>(b)</strong> any breach by you of the Trial Period Terms And
      Conditions.
    </li>
  </ul>

  <h3 id="governing-law">6. Governing Law and General Provisions</h3>
  <p>
    These Trial Period Terms and Conditions shall be governed by, and construed
    in accordance with, the laws of the Commonwealth of Virginia, without regard
    to its choice of law principles. These Trial Period Terms and Conditions
    constitute the entire agreement between the parties pertaining to the
    subject matter hereof, and cancel and supersede all prior oral and written
    negotiations, agreements or understandings between the parties with respect
    to the subject matter hereof.
  </p>
  <p>
    No modification of any provision of these Trial Period Terms and Conditions
    shall be valid or binding unless made in writing and signed by an authorized
    officer of Company. Company's failure at any time to require performance of
    any provision of this Agreement or to exercise any right provided for herein
    shall not be deemed a waiver of such provision or such right. All waivers
    must be in writing.
  </p>
  <p>
    These Trial Period Terms and Conditions are personal to you and you may not
    transfer or assign any of your rights or obligations hereunder without the
    prior written consent of Company.
  </p>
</div>
